module.exports = __webpack_public_path__ + "static/media/land.a2bb2f66.svg";